import { getRuntimeConfig } from '../config/runtimeConfig';

export const LOGIN_APP_PATH: string = '/login';
export const ALL_FORMS_PATH: string = '/processes';
export const EDIT_FORM_PATH: string = '/edit-form';
export const CREATE_FORM_PATH: string = '/create-form';

export const SEND_OTP_PATH = '/send-otp';
export const VERIFY_OTP_PATH = '/verify-otp';
export const GET_FORMS_METADATA_PATH = '/forms-metadata';
export const GET_FORM_TEMPLATE_PATH = '/get-form-template';
export const GET_FORM_STRUCTURE_PATH = '/get-form-structure';
export const GET_FORM_STRINGS_PATH = '/get-form-strings';
export const UPDATE_FORM_TEMPLATE_PATH = '/update-form-template';
export const DELETE_FORM_TEMPLATE_PATH = '/delete-form-template';
export const GET_ALL_QUESTIONS_PATH = '/fetch-all-questions';
export const GENERATE_PREVIEW_LINK_PATH = '/generate-preview-link';

export const BEETLE_PATH: string = '/beetle';

export function getServerUrl(): string {
  return getRuntimeConfig().REACT_APP_SERVER_URL;
}

export function getSendOtpServerUrl(): string {
  return `${getServerUrl()}${BEETLE_PATH}${SEND_OTP_PATH}`;
}

export function getVerifyOtpServerUrl(): string {
  return `${getServerUrl()}${BEETLE_PATH}${VERIFY_OTP_PATH}`;
}

export function getFormsMetadataServerUrl(): string {
  return `${getServerUrl()}${BEETLE_PATH}${GET_FORMS_METADATA_PATH}`;
}

export function getFormTemplateServerUrl(): string {
  return `${getServerUrl()}${BEETLE_PATH}${GET_FORM_TEMPLATE_PATH}`;
}

export function getFormStructureServerUrl(formId: string): string {
  return `${getServerUrl()}${BEETLE_PATH}${GET_FORM_STRUCTURE_PATH}/${formId}`;
}

export function getFormStringsServerUrl(formId: string, lang: string): string {
  return `${getServerUrl()}${BEETLE_PATH}${GET_FORM_STRINGS_PATH}/${formId}/${encodeURIComponent(lang)}`;
}

export function getUpdateFormTemplateServerUrl(): string {
  return `${getServerUrl()}${BEETLE_PATH}${UPDATE_FORM_TEMPLATE_PATH}`;
}

export function getDeleteFormTemplateServerUrl(): string {
  return `${getServerUrl()}${BEETLE_PATH}${DELETE_FORM_TEMPLATE_PATH}`;
}

export function getAllQuestionsServerUrl(): string {
  return `${getServerUrl()}${BEETLE_PATH}${GET_ALL_QUESTIONS_PATH}`;
}

export function getGeneratePreviewLinkServerUrl(): string {
  return `${getServerUrl()}${BEETLE_PATH}${GENERATE_PREVIEW_LINK_PATH}`;
}

export const LANGUAGE_ITEM_NAME: string = 'languageStorageItem';

export const MAX_VERIFY_OTP_ERROR = 'max verify otp attempts reached';
export const MAX_SEND_OTP_ERROR = 'max send otp attempts reached';
